export const VOWEL_COST = 250;
export const MIN_CASH_SPIN = 100;
export const MAX_PLAYERS = 8;
export const MIN_ROUNDS = 1;
export const MAX_ROUNDS = 10;

export const VOWELS = ['a', 'e', 'i', 'o', 'u'] as const;

export const SLOT_SPECIALS = [
  '$$$',
  '$$$',
  '$$$',
  '$$$',
  '$$$',
  '$$$',
  '$$$',
  'LOSE TURN',
  'LOSE TURN',
  'BANKRUPT',
] as const;

export type SpecialReel = (typeof SLOT_SPECIALS)[number];
export type GameStatus = 'lobby' | 'playing' | 'finished';
export type GamePhase =
  | 'lobby'
  | 'awaiting_action'
  | 'awaiting_consonant'
  | 'round_complete'
  | 'game_over';

export interface Player {
  id: string;
  name: string;
  roundScore: number;
  totalScore: number;
  isHost: boolean;
}

export interface SpinResult {
  reelValues: [number, number, number, number];
  specialValue: SpecialReel;
  cashValue: number;
}

export interface Category {
  id: string;
  name: string;
  puzzles: string[];
}

export interface GameState {
  id: string;
  hostId: string;
  playerIds: string[];
  players: Player[];
  status: GameStatus;
  phase: GamePhase;
  totalRounds: number;
  currentRound: number;
  selectedCategoryIds: string[];
  usedPuzzles: string[];
  currentPhrase: string;
  currentCategory: string;
  currentPlayerIndex: number;
  currentSpinValue: number | null;
  lastSpin: SpinResult | null;
  lastSpinAt: number | null;
  guessedLetters: string[];
  message: string;
  winners: Player[];
  createdAt: number;
  updatedAt: number;
}

export type GameAction =
  | { type: 'JOIN'; playerId: string; playerName: string }
  | { type: 'SET_CONFIG'; playerId: string; totalRounds: number; selectedCategoryIds: string[] }
  | { type: 'START'; playerId: string }
  | { type: 'SPIN'; playerId: string; spin: SpinResult }
  | { type: 'GUESS_CONSONANT'; playerId: string; letter: string }
  | { type: 'BUY_VOWEL'; playerId: string; letter: string }
  | { type: 'SOLVE'; playerId: string; guess: string }
  | { type: 'ADVANCE_ROUND'; playerId: string }
  | { type: 'END_GAME'; playerId: string };

export interface EngineDeps {
  now?: number;
  pickPuzzle?: (categoryId: string, usedPuzzles: string[]) => { phrase: string; categoryName: string };
}

export interface AvailableActions {
  canSpin: boolean;
  canGuessConsonant: boolean;
  canBuyVowel: boolean;
  canSolve: boolean;
  canEndGame: boolean;
  canAdvance: boolean;
  isMyTurn: boolean;
  isHost: boolean;
}
